import { Button } from '@acpaas-ui/react-components';
import { useDispatch } from 'react-redux';
import { fetchReset } from '../../../../actions/fetch.actions';
import SimpleSearch from '../../../../components/core/SimpleSearch';
import { MODALS } from '../../../../constants/modals.constants';
import { useForm } from '../../../../hooks/useForm.hook';
import { useModal } from '../../../../hooks/useModal.hook';
import { useSimpleSearch } from '../../../../hooks/useSimpleSearch.hook';
import AddThemeModal from '../../../../modals/admin/AddThemeModal';
import DeleteWarningModal from '../../../../modals/DeleteWarningModal';
import UpdateThemeModal from '../../../../modals/admin/UpdateThemeModal';
import { ADMIN_OFFERING_THEMES_RESOURCE } from '../../../../resources/admin/admin.offering.themes.resource';
import themesService from '../../../../services/api/themes.service';
import ResourceTable from '../../../core/ResourceTable';
import { useAdminRouteGuard } from '../../../../hooks/admin/useAdminRouteGuard.hook';

const AdminThemes = () => {
  const dispatch = useDispatch();
  const addThemeModal = useModal(MODALS.ADD_THEME_MODAL);
  const updateThemeModal = useModal(MODALS.UPDATE_THEME_MODAL);
  const deleteThemeModal = useModal(MODALS.DELETE_THEME_MODAL);
  const themeForm = useForm({ name: '' });

  useAdminRouteGuard();

  const handleThemeOpen = (data) => {
    themeForm.load(data);
    updateThemeModal.onOpen();
  };

  const handleDeleteRequest = () => {
    deleteThemeModal.onOpen();
  };

  const handleDeleteConfirm = (onError, onSuccess) => {
    themesService.remove(themeForm.data.id, {
      onError,
      onSuccess: () => {
        onSuccess();
        updateThemeModal.onClose();
        themeForm.load({ name: '' });
        dispatch(fetchReset(ADMIN_OFFERING_THEMES_RESOURCE));
      }
    });
  };

  return (
    <div className="spo-o-admin-themes">
      <p className="u-margin-bottom-lg">
        Doorheen de applicatie worden de labels van de dossiers gebruikt als labels om meer duiding te geven, op te
        kunnen filteren en op te kunnen rapporteren. De lijst van labels kan hier beheerd worden.
      </p>
      <SimpleSearch className="u-margin-bottom-lg" {...useSimpleSearch(ADMIN_OFFERING_THEMES_RESOURCE, 'name')} />
      <ResourceTable
        resource={ADMIN_OFFERING_THEMES_RESOURCE}
        onRowClick={handleThemeOpen}
        actions={[
          <Button
            key="add-theme"
            iconRight="ai-add"
            size="small"
            className="u-margin-right"
            onClick={addThemeModal.onOpen}
          >
            Label toevoegen
          </Button>
        ]}
      />
      <AddThemeModal {...addThemeModal} />
      <UpdateThemeModal {...updateThemeModal} form={themeForm} onDelete={handleDeleteRequest} />
      <DeleteWarningModal {...deleteThemeModal} onConfirm={handleDeleteConfirm} />
    </div>
  );
};

export default AdminThemes;
